export const DefaultComponents = {
  defaultPaymentType: "",
  paymentTypes: [""],
  startOnLoad: false,
};
